import { CobaltButton } from '@cae/cobalt-react/components/button';
import { CobaltLoaderCircular } from '@cae/cobalt-react/components/loader-circular';
import * as React from 'react';

import type { DisciplineActionProps } from './DisciplineAction.types';

import styles from './DisciplineAction.module.css';
import { DISCIPLINE_ACTION_CONFIG } from './DisciplineAction.utils';

const DisciplineAction = React.memo(
  ({
    state,
    canEdit,
    onClick,
    disabled,
    isLoading,
  }: Readonly<DisciplineActionProps>): React.ReactElement => {
    const config = DISCIPLINE_ACTION_CONFIG[state];
    if (!config || !canEdit) {
      return <></>;
    }
    return (
      <CobaltButton
        variant={config.variant}
        size="x-small"
        className={styles.disciplineActionButton}
        onClick={onClick}
        disabled={disabled}
      >
        {config.label}
        {isLoading && <CobaltLoaderCircular size="small" />}
      </CobaltButton>
    );
  }
);

DisciplineAction.displayName = 'DisciplineAction';
export { DisciplineAction };
